import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'edl-modal-confirm-notes',
    templateUrl: './edl-modal-confirm-notes.component.html',
    styleUrls:   ['./edl-modal-confirm-notes.component.scss']
})
export class EdlModalConfirmNotes {
    @Input() title: string;
    @Input() message: string;
    @Input() textAreaInstructions: string;
    @Input() noteLabel: string = 'Comments';
    @Input() noteRequired: boolean = false;

    noteForm: UntypedFormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder) {}

    ngOnInit() {
        this.noteForm = this.formBuilder.group({
            Message: [null, this.noteRequired ? [Validators.required] : []]
        });
    }
    submit() {
        if (this.noteForm.invalid) {
            this.noteForm.markAllAsTouched();
            return;
        }

        let messageBox: AbstractControl = this.noteForm.get('Message');
        let message = messageBox.value;
        this.activeModal.close(message);
    }
}
